import React, { useState } from 'react';
import {
  Carousel,
  CarouselContainer,
  CarouselControl,
  CarouselControls,
  CarouselInnerImage,
  CarouselItem,
  CarouselOuterWrapper
} from './styles';

const ImageCarousel = ({ images, setActiveImage, onScreenCount }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activePreview, setActivePreview] = useState(0);

  return (
    <CarouselOuterWrapper>
      <CarouselContainer>
        <Carousel
          moveValue={100 / onScreenCount}
          currentIndex={currentIndex}
          totalChild={images.length}
        >
          {images.map((image, idx) => (
            <CarouselItem
              key={image.id}
              width={100 / onScreenCount}
              onMouseEnter={() => {
                setActiveImage(image.url);
                setActivePreview(idx);
              }}
            >
              <CarouselInnerImage active={activePreview === idx} src={image.url} />
            </CarouselItem>
          ))}
        </Carousel>
      </CarouselContainer>
      <CarouselControls>
        <CarouselControl
          onClick={() => {
            setCurrentIndex(Math.max(currentIndex - 1, 0));
          }}
          className="carousel-control-prev"
        >
          <img src="/svg/packageScreen/prev-arrow.svg" alt="arrrow" />
        </CarouselControl>
        <CarouselControl
          onClick={() => {
            const numItems = images.length;
            setCurrentIndex(Math.min(currentIndex + 1, numItems - 1));
          }}
          className="carousel-control-next"
        >
          <img src="/svg/packageScreen/next.svg" alt="arrrow" />
        </CarouselControl>
      </CarouselControls>
    </CarouselOuterWrapper>
  );
};

export default ImageCarousel;
